import { useState } from "react";
import { supabase } from "../lib/supabase";
import { C } from "../constants/colors";

export function ArtworkEditModal({ image, onClose, onSaved, onDeleted }) {
  const [form, setForm] = useState({
    title:       image.title       || '',
    medium:      image.medium      || '',
    year:        image.year        || '',
    dimensions:  image.dimensions  || '',
    price:       image.price       || '',
    description: image.description || '',
  });
  const [saving, setSaving] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState(null);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.title.trim()) { setError('Title is required.'); return; }
    setSaving(true); setError(null);
    const { error: err } = await supabase.from('portfolio_images')
      .update({ title: form.title.trim(), medium: form.medium||null, year: form.year?Number(form.year):null, dimensions: form.dimensions||null, price: form.price||null, description: form.description||null })
      .eq('id', image.id);
    setSaving(false);
    if (err) { setError(err.message); return; }
    onSaved({ ...image, ...form });
    onClose();
  };

  const handleDelete = async () => {
    setSaving(true);
    // Extract storage path from URL
    const url = image.image_url;
    const bucketPath = url.split('/portfolio-images/')[1];
    if (bucketPath) {
      await supabase.storage.from('portfolio-images').remove([decodeURIComponent(bucketPath)]);
    }
    await supabase.from('portfolio_images').delete().eq('id', image.id);
    setSaving(false);
    onDeleted(image.id);
    onClose();
  };

  const inp = { background:C.parch, border:`1px solid ${C.sand}`, borderRadius:6, padding:"9px 11px", fontSize:".83rem", color:C.bark, width:"100%", boxSizing:"border-box", outline:"none", fontFamily:"inherit" };
  const lbl = { fontSize:".62rem", fontFamily:"'DM Mono',monospace", letterSpacing:"1px", textTransform:"uppercase", color:C.muted, display:"block", marginBottom:4 };

  return (
    <div style={{ position:"fixed",inset:0,zIndex:200,display:"flex",alignItems:"flex-start",justifyContent:"center",background:"rgba(40,30,20,.6)",overflowY:"auto",padding:"24px 16px" }}>
      <div style={{ background:C.parch,borderRadius:12,width:"100%",maxWidth:480,padding:"28px 24px",boxShadow:"0 8px 40px rgba(0,0,0,.2)" }}>
        <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20 }}>
          <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"1.3rem",fontWeight:400,color:C.bark,margin:0 }}>Edit Artwork</h2>
          <button onClick={onClose} style={{ background:"none",border:"none",fontSize:"1.2rem",cursor:"pointer",color:C.muted,padding:4 }}>✕</button>
        </div>
        <img src={image.image_url} alt={image.title} style={{ width:"100%",maxHeight:200,objectFit:"cover",borderRadius:8,marginBottom:18 }}/>
        <div style={{ marginBottom:12 }}>
          <label style={lbl}>Title *</label>
          <input style={inp} value={form.title} onChange={e=>set('title',e.target.value)}/>
        </div>
        <div style={{ display:"flex",gap:10,marginBottom:12 }}>
          <div style={{ flex:2 }}>
            <label style={lbl}>Medium</label>
            <input style={inp} value={form.medium} onChange={e=>set('medium',e.target.value)} placeholder="e.g. Oil on linen"/>
          </div>
          <div style={{ flex:1 }}>
            <label style={lbl}>Year</label>
            <input style={inp} value={form.year} onChange={e=>set('year',e.target.value)} placeholder="2024"/>
          </div>
        </div>
        <div style={{ display:"flex",gap:10,marginBottom:12 }}>
          <div style={{ flex:1 }}>
            <label style={lbl}>Dimensions</label>
            <input style={inp} value={form.dimensions} onChange={e=>set('dimensions',e.target.value)} placeholder="e.g. 90 × 120 cm"/>
          </div>
          <div style={{ flex:1 }}>
            <label style={lbl}>Price (AUD)</label>
            <input style={inp} value={form.price} onChange={e=>set('price',e.target.value)} placeholder="e.g. 2,400 or NFS"/>
          </div>
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={lbl}>Description</label>
          <textarea style={{ ...inp,minHeight:70,resize:"vertical" }} value={form.description} onChange={e=>set('description',e.target.value)} placeholder="Notes about the work…"/>
        </div>
        {error && <div style={{ background:C.roseL,border:`1px solid ${C.rose}`,borderRadius:5,padding:"9px 12px",marginBottom:12,fontSize:".8rem",color:C.rose }}>⚠ {error}</div>}
        {confirming ? (
          <div style={{ background:C.roseL,border:`1px solid ${C.rose}`,borderRadius:8,padding:"14px",marginBottom:0 }}>
            <div style={{ fontSize:".83rem",color:C.rose,marginBottom:12 }}>Delete this artwork? This cannot be undone.</div>
            <div style={{ display:"flex",gap:8 }}>
              <button className="btn-dk" style={{ flex:1,padding:"10px" }} onClick={()=>setConfirming(false)}>Cancel</button>
              <button style={{ flex:1,padding:"10px",background:C.rose,border:"none",borderRadius:6,color:"#fff",cursor:"pointer",fontSize:".82rem" }} onClick={handleDelete} disabled={saving}>Delete</button>
            </div>
          </div>
        ) : (
          <div style={{ display:"flex",gap:10 }}>
            <button className="btn-dk" style={{ padding:"11px 14px" }} onClick={()=>setConfirming(true)} disabled={saving}>🗑</button>
            <button className="btn-dk" style={{ flex:1,padding:"11px" }} onClick={onClose} disabled={saving}>Cancel</button>
            <button className="btn-p" style={{ flex:2,padding:"11px" }} onClick={handleSave} disabled={saving}>{saving?"Saving…":"Save changes"}</button>
          </div>
        )}
      </div>
    </div>
  );
}
